import { useEffect } from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { Button } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { Typography } from '@mui/material';
import MDemandeAutorisation from '../../../../Models/MDemandeAutorisation' //'../../../Models/Classes/MDemandeAutorisation';
import formatDate from '../../../../Functions/Traitement/fomatDate' //'../../../function/FormDate';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate' //'../../../function/ReformDate';
import Swal from 'sweetalert2';
import { SettingsSuggest } from '@mui/icons-material';
import Demand from '../../../../Models/MDemandeAutorisation';
import Format from '../../../../Functions/Traitement/Format';



//*************************************************************************** */
import { Form, Select, Spin } from 'antd';
import Table from '../../../TableResizable';
import SearInputModal from "../../../SearchModal" //"../../../Composants/SearchModal";
import SearInputG from "../../../SearchInput" //"../../../Composants/SearchInput";
import ParamsPicklist from "../../../../Types/ParamsPicklist"  // "../../../../../Models/Types/ParamsPicklist";
import InputForm from "../../../InputT" //"../../../Composants/InputT";
import { Checkbox, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { Box } from "@mui/material";
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import { Crypter } from "../../../../Functions/Security/Crypter";
import Data from '../../../../Data/Data.json'
import SearInputM from '../../../SearchModal';
import type { SelectProps, TableColumnsType } from 'antd';
import { useAuthHeader, useAuthUser } from "../../../../Services/Auth/sessionAuth";
import axios from "axios";
import SweetAlert from "sweetalert2"
import DataType from "../../../../Functions/Traitement/DataPeriodAuto";
import DataPeriod1 from "../../../../Functions/Traitement/DataPeriodAuto";
import Utilisateur from "../../../../Models/Utilisateur";
import formatNumber from '../../../../Functions/Traitement/FormatNumber';



// lien vers le fichier JSON



const AddAutorisation = () => {
    // USER SESSION
    // USER SESSION
    // const auth = useAuthUser()
    // const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))


    // const auth = useAuthUser()
    // const user : Utilisateur = JSON.parse(JSON.stringify(auth()))
    // USER TOKEN
    // DECLARATION DES USTATES

    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    //const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")


    const handleConsultCompte = async () => {
        setLoading(true);
        let NUMCPT = '';
        NUMCPT = form.getFieldValue('CPTAUT');
        let data = Crypter.encrypt(NUMCPT);
        //form.setFieldsValue({ 'DISPONEM': '' })
        let config1 = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetCompte,
            headers: {
                'CypherNumCpte': data,
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
            },
        };
        let requestOne = axios.request(config1);

        await axios
            .all([requestOne])
            .then(
                await axios.spread(async (...responses: any) => {
                    const responseOne = responses[0];
                    if (responseOne.data) {
                        const res = JSON.parse(Crypter.decrypt(responseOne.data));
                        if (res.StatutCode == 200) {
                            let datas = res.Result.Table[0];
                            if (res.Result.Table.length > 0) {

                                // alert(datas.DISPON)
                                // alert(formatNumber(datas.DISPON))
                                form.setFieldValue('DISPON', formatNumber(datas.DISPON));
                            } else {
                                SweetAlert.fire({ title: "Warning", text: "Compte not found", icon: "warning" })
                            }
                        }
                        else {
                            setLoading(false);
                            SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
                        }
                    }
                }
                )).catch((errors) => {
                    SweetAlert.fire({ title: "error", text: errors.message, icon: "error" })
                });

        setLoading(false);
    }


    function handleConsult() {
        localStorage.clear()
        sessionStorage.clear()
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setConsulte(true);
        setSearchGlobal(true);
        setLibell(true);
    }

    function handleAjout() {
        setSbmit("add")
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSearchGlobal(true);
        setLibell(true);
        form.resetFields()
    }

    function handleModife() {
        setSbmit("update")
        setModife(true);
        setSupprime(false);
        setEnrege(false);
        setFormactve(false);
        setLibell(true);
    }

    function handleSupprim() {

    }

    function handleEnreg() {

    }

    function handleActual() {
        form.resetFields();
        form.setFieldValue("lib_DEVAUT", "FRANC CFA BEAC")
    }

    function handleAnnul() {
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        setFormactve(true);
        handleActual()
        form.resetFields()
        form.setFieldValue("lib_DEVAUT", "FRANC CFA BEAC")
        setLibell(false);
    }


    function consult() {

        if (form.getFieldValue("NUMCRD") == null) {
            SweetAlert.fire({ title: "Svp renseigner le numero de l'autorisation", icon: "warning" })
        } else {
            let data = Crypter.encrypt(form.getFieldValue("NUMCRD"));
            handleConsult()

            if (data.length != 0) {
                setLoading(true)
                form.resetFields()
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadAutorisation,
                    headers: {
                        'CypherNumcrd': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            console.log(JSON.stringify(res))
                            let Autorisation = res.Result.Table[0]

                            if (res.StatutCode == 200) {

                                form.setFieldsValue(Autorisation);

                                // form.setFieldValue('lib_NUMCRD', ReformatDate(Autorisation.lib_IDClient));
                                form.setFieldValue('DATEFF', ReformatDate(Autorisation.DATEFF));
                                form.setFieldValue('DATEFIN', ReformatDate(Autorisation.DATEFIN));
                                // form.setFieldValue('lib_IDLIMITE', Autorisation.NOMCLI)
                                form.setFieldValue('MONTAN1', Autorisation.MONTAN)
                                Getselectcli2()

                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }

    }

    //********************* */
    function Getselectcli() {
        setlim(form.getFieldValue("NUMCLI"))
        //RemplirGarantie()
        form.setFieldValue("IDLIMITE", '')
        form.setFieldValue("lib_IDLIMITE", '')
        form.setFieldValue("NivCons", '')
        form.setFieldValue("MNTlimite", '')

    }



    const onFinish = (values: any) => {
        console.log(values)
        var DemandAuto: Demand = values

        DemandAuto.DATEFF = formatDate(DemandAuto.DATEFF);
        DemandAuto.DATVAL = DemandAuto.DATEFF;
        DemandAuto.DATDRV = DemandAuto.DATEFF;
        DemandAuto.DATEFIN = formatDate(DemandAuto.DATEFIN);
        DemandAuto.DATPRV = DemandAuto.DATEFF;
        DemandAuto.MONTAN = form.getFieldValue("MONTAN1");
        DemandAuto.AGCLOC = Perss.codage;
        

        var niv = 0;

        if (form.getFieldValue("Nivcons") == null) {
            niv = 0;
        } else {
            niv = form.getFieldValue("Nivcons");
        }

        var dateff = new Date(form.getFieldValue("DATEFF"));
        var datfin = new Date(form.getFieldValue("DATEFIN"));

        if (form.getFieldValue("MNTAUT") > form.getFieldValue("RESTANT")) {
            SweetAlert.fire({ title: "", text: "Opération Impossible :Le montant du découvert est supérieur au reste de la limite", icon: "warning" })
        } else {
            if (sbmit == "add") {
                // verifier la difference de date de l'autorisation
                if (dateff >= datfin) {
                    SweetAlert.fire({ text: "Opération Impossible : La date Effet doit être inferieur à la date Fin ", icon: "warning" })
                } else {
                    // verifier la difference entre la date debut auto et debut limite
                    if ((form.getFieldValue("DATEFF")) < (form.getFieldValue("datedebut")) || (form.getFieldValue("DATEFF")) > (form.getFieldValue("Ldatefin"))) {
                        SweetAlert.fire({ text: "Opération Impossible : La date Effet doit être supérieur ou égale à la date debut de la Limite ", icon: "warning" })
                    } else {
                        // verifier la difference entre la date fin auto et fin limite
                        if (form.getFieldValue("DATEFIN") > (form.getFieldValue("Ldatefin"))) {
                            SweetAlert.fire({ text: "Opération Impossible : La date fin doit être inferieur à la date fin de la limite ", icon: "warning" })
                        } else {

                            if ((form.getFieldValue("MNTAUT")) > (form.getFieldValue("MNTlimite") - niv)) {
                                SweetAlert.fire({ text: "Opération Impossible : le montant de la demande doit etre <= au montant restant de la limite ", icon: "warning" })
                            } else {

                                SweetAlert.fire({
                                    title: "Enregistrement de DemandAuto",
                                    text: "Voulez-vous enregistrer la DemandAuto de " + values.lib_NUMCLI + " ?",
                                    showCancelButton: true,
                                    color: "green",
                                    confirmButtonText: "Yes",
                                    confirmButtonColor: "green",
                                    cancelButtonColor: "darkred",
                                    cancelButtonText: "No",
                                    showLoaderOnConfirm: true,
                                    icon: "question"
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        setLoading(true);
                                        setIsSubmit(true)
                                        //let group = profilsDistant.find(()=>)
                                        DemandAuto.UTILIS = Perss.coduti;

                                        let data = Crypter.encrypt(JSON.stringify(DemandAuto));

                                        let config = {
                                            method: 'post',
                                            maxBodyLength: Infinity,
                                            url: Data.ApiUrl.CreateDemandeAutorisation,
                                            headers: {
                                                'CypherDemandeAuto': data,
                                                'Authorization': authHeader(),
                                                'Content-Type': 'application/json'
                                            },
                                            data: data
                                        };

                                        axios.request(config)
                                            .then((response) => {
                                                setLoading(false);
                                                if (response.data) {
                                                    const res = JSON.parse(Crypter.decrypt(response.data));

                                                    if (res.StatutCode == 200) {
                                                        let code = res.Result
                                                        form.resetFields()
                                                        localStorage.clear()
                                                        setIsSubmit(false)

                                                        //DJ
                                                        if (code == "DJ") {
                                                            SweetAlert.fire({ text: "Creation Impossible: le Membre Posséde Déja une en Attente de Validation sur le même Compte bien vouloir le valider ou le rejeter d'abord", icon: "warning" })
                                                        } else if (code == "ErreurJr") {
                                                            SweetAlert.fire({ text: "Creation Impossible: la journée comptable n'est pas ouverte", icon: "warning" })
                                                        } else {
                                                            SweetAlert.fire({ title: '' + res.Message, text: "Opération Réussi Reférence : " + code, icon: "success" })
                                                            localStorage.clear()
                                                            handleAnnul()
                                                            setSbmit("")
                                                        }


                                                    }
                                                    else {
                                                        SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                                    }
                                                }
                                            })
                                            .catch((error) => {
                                                setLoading(false);
                                                console.log(error)
                                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                            });

                                    }
                                })
                            }
                        }
                    }
                }
            }
            if (sbmit == "update") {

                // verifier la difference de date de l'autorisation
                if (dateff >= datfin) {
                    SweetAlert.fire({ text: "Opération Impossible : La date Effet doit être inferieur à la date Fin ", icon: "warning" })
                } else {
                    // verifier la difference entre la date debut auto et debut limite
                    if ((form.getFieldValue("DATEFF")) < (form.getFieldValue("datedebut")) || (form.getFieldValue("DATEFF")) > (form.getFieldValue("Ldatefin"))) {
                        SweetAlert.fire({ text: "Opération Impossible : La date Effet doit être supérieur ou égale à la date debut de la Limite ", icon: "warning" })
                    } else {
                        // verifier la difference entre la date fin auto et fin limite
                        if (form.getFieldValue("DATEFIN") > (form.getFieldValue("Ldatefin"))) {
                            SweetAlert.fire({ text: "Opération Impossible : La date fin doit être inferieur à la date fin de la limite ", icon: "warning" })
                        } else {

                            if ((form.getFieldValue("MNTAUT")) > (form.getFieldValue("MNTlimite") - niv)) {
                                SweetAlert.fire({ text: "Opération Impossible : le montant de la demande doit etre <= au montant restant de la limite ", icon: "warning" })
                            } else {
                                SweetAlert.fire({
                                    title: "Mise a jour de DemandAuto",
                                    text: "Voulez-vous modifier la demande de " + values.lib_NUMCLI + " ?",
                                    showCancelButton: true,
                                    color: "green",
                                    confirmButtonText: "Yes",
                                    confirmButtonColor: "green",
                                    cancelButtonColor: "darkred",
                                    cancelButtonText: "No",
                                    showLoaderOnConfirm: true,
                                    icon: "question"
                                }).then((res) => {

                                    if (res.isConfirmed) {
                                        setLoading(true);
                                        setIsSubmit(true)
                                        //let group = profilsDistant.find(()=>)
                                        console.log(JSON.stringify(DemandAuto))
                                        let data = Crypter.encrypt(JSON.stringify(DemandAuto));

                                        // alert(DemandAuto.NUMCRD);
                                        // alert(DemandAuto.IDLIMITE);

                                        let config = {
                                            method: 'put',
                                            maxBodyLength: Infinity,
                                            url: Data.ApiUrl.UpdateAutorisation,
                                            headers: {
                                                'CypherDemandeAuto': data,
                                                'Authorization': authHeader(),
                                                'Content-Type': 'application/json'
                                            },
                                            data: data
                                        };

                                        axios.request(config)
                                            .then((response) => {
                                                setLoading(false);
                                                if (response.data) {
                                                    const res = JSON.parse(Crypter.decrypt(response.data));

                                                    if (res.StatutCode == 200) {
                                                        let code = res.Result
                                                        form.resetFields()
                                                        localStorage.clear()
                                                        setIsSubmit(false)
                                                        // SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })


                                                        if (code == "ErreurJr") {
                                                            SweetAlert.fire({ text: "Mise à Jour Impossible: la journée comptable n'est pas ouverte", icon: "warning" })
                                                        } else if (code == "ErreurSt") {
                                                            SweetAlert.fire({ text: "Mise à Jour Impossible: l'etat de la demande a traversé l'étape de validation", icon: "warning" })
                                                        } else {
                                                            SweetAlert.fire({ title: '' + res.Message, text: "Opération Réussi Reférence : " + code, icon: "success" })
                                                        }

                                                        localStorage.clear()
                                                        handleAnnul()

                                                        setSbmit("")
                                                    }
                                                    else {
                                                        SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                                    }
                                                }
                                            })
                                            .catch((error) => {
                                                setLoading(false);
                                                console.log(error)
                                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                                            });

                                    }
                                })
                            }
                        }
                    }
                }
            }
        }

    }


    //******************************************************************************************************** */

    // Pour remplir les labels

    const { t, i18n } = useTranslation();
    let InfoDemandeAutorisation = {
        numauto: t("FormDemandeAutorisation.numauto"),
        idclt: t("FormDemandeAutorisation.idclt"),
        numcpte: t("FormDemandeAutorisation.numcpte"),
        natcre: t("FormDemandeAutorisation.natcre"),
        libdevi: t("FormDemandeAutorisation.libdevi"),
        Libserv: t("FormDemandeAutorisation.Libserv"),
        libmtant: t("FormDemandeAutorisation.libmtant"),
        libperiod: t("FormDemandeAutorisation.libperiod"),
        libgaranti: t("FormDemandeAutorisation.libgaranti"),
        libfrais: t("FormDemandeAutorisation.libfrais"),
        librenew1: t("FormDemandeAutorisation.librenew1"),
        librenew2: t("FormDemandeAutorisation.librenew2"),
        libperiodj: t("FormDemandeAutorisation.libperiodj"),
        libcmd1: t("FormDemandeAutorisation.libcmd1"),
        libcmd2: t("FormDemandeAutorisation.libcmd2"),
        libcmb3: t("FormDemandeAutorisation.libcmb3"),
        libmtant1: t("FormDemandeAutorisation.libmtant1"),
        libmtant2: t("FormDemandeAutorisation.libmtant2"),
        libmtant3: t("FormDemandeAutorisation.libmtant3")
    };
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // pour le resultat des picklists
     // ok 
  
    let searchCsion: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '', colfiltre:"",valfiltre:'', Choix: 22  }
    let searchAutorisation: ParamsPicklist = { CodeAgence: Perss.codage, Table: "AUTORISATION", Colonne1: "NUMCRD", Colonne2: "NOMCLI", Colagence: 'AGCLOC', Choix: 22 }
    let searchClient: ParamsPicklist = { CodeAgence: Perss.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'CODAGE', Choix: 22 }

    let searchDevise: ParamsPicklist = { CodeAgence: '', Table: "DEVISE", Colonne1: "CODDEV", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
    let searchNatcrd: ParamsPicklist = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }




    // gestion de la limite avec ok
    const [Lim, setlim] = useState('aba')
      //let searchNum: ParamsPicklist = { CodeAgence: user.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "AGCCPT",colfiltre:"TYPCPT",valfiltre:'I', Choix: 22 }

    let searchlimite: ParamsPicklist = { CodeAgence: Perss.codage, Table: "LIMITE", Colonne1: "IDLIMITE", Colonne2: "IDClient", Colagence: 'codeage', colfiltre:"IDClient",valfiltre:Lim, Choix: 22   }
    let searchCompte: ParamsPicklist = { CodeAgence: Perss.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'agccpt', colfiltre:"NUMCLI",valfiltre:Lim, Choix: 22  }

    function Getselectcli2() {
        GetLimite()

    }

    // Handle pour la selection des element dans le tableau
    
    
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [donnees, setData] = useState<DataType[]>([]);
    const [Libell, setLibell] = useState(false)



    //***************************************************************************************************/
    //********************** Function Pour Afficher les Commissions à Afficher **************************/
    function change(e: any, indexe: number) {
        let value = e.target.value as number
        var t = 0
        if (value + "" == "") {
            form.setFieldValue("MONTAN" + indexe, 0)
        } else {
            form.setFieldValue("MONTAN" + indexe, value)
        }
        for (let i = 1; i <= commissions.length; i++) {
            var tmp = parseInt(form.getFieldValue("MONTAN" + i) + "") ? parseInt(form.getFieldValue("MONTAN" + i) + "") : 0
            t = t + tmp
            //console.log(t)
        }
        //alert(t)
        form.setFieldValue("cssionApliq", t)
    }

    //***************************************************************************************************/
    //********************** Tableau pour la liste des Commissions à Afficher ***************************/
    const commissions = [
        {
            indexe: 1,
            code: "940",
            label: "CION N1/ MISE EN PLACE DECOUVERT/FACILITE"
        },
        {
            indexe: 2,
            code: "941",
            label: "CION N2/ MISE EN PLACE DECOUVERT/FACILITE"
        },
        {
            indexe: 3,
            code: "942",
            label: "CION N3/ MISE EN PLACE DECOUVERT/FACILITE"
        }
        // ,
        // {
        //     indexe: 4,
        //     code: "949",
        //     label: "CION N°4/MISE EN PLACE PRET"
        // }
    ]

    //***************************************************************************************************/
    //********************** Usestate Pour La gestion des états des Montants Commissions ****************/
    const [checked1, setChecked1] = React.useState(true);
    const [checked2, setChecked2] = React.useState(true);
    const [checked3, setChecked3] = React.useState(true);
    const [checked4, setChecked4] = React.useState(true);

    const [loadMont1, setLoadMont1] = React.useState(false);
    const [loadMont2, setLoadMont2] = React.useState(false);
    const [loadMont3, setLoadMont3] = React.useState(false);
    const [loadMont4, setLoadMont4] = React.useState(false);

    const tabCheck = [checked1, checked2, checked3, checked4]

    //***************************************************************************************************/
    //********************** Function Pour la gestion des Montant des commissions ***********************/
    const onChange = (cssion: any) => {

        let montant = form.getFieldValue("MNTAUT");

        if (montant > 0) {

            let indexe = cssion.indexe
            let mont = 0;
            switch (indexe) {
                case 1:
                    setChecked1(!checked1)
                    setLoadMont1(true);
                    break;
                case 2:
                    setChecked2(!checked2)
                    setLoadMont2(true);
                    break;
                case 3:
                    setChecked3(!checked3)
                    setLoadMont3(true);
                    break;
                case 4:
                    setChecked4(!checked4)
                    setLoadMont4(true);
                    break;
                default:
                    break;
            }

            const datat: DataType[] = [];
            var datas = { commission: null }
            //var data = { CodeAgence: searchMontantCsion?.CodeAgence, Table: searchMontantCsion?.Table, Colonne1: searchMontantCsion?.Colonne1, Colonne2: searchMontantCsion?.Colonne2, Colagence: searchMontantCsion?.Colagence, Init: cssion.code, choix: searchMontantCsion?.Choix }
            var com = { "CodOpe": cssion.code, Montant: montant, "CodAge": Perss.codage }

            var config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetCommission,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                    'CypherCommission': Crypter.encrypt(JSON.stringify(com))
                }
            };
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                        if (res.StatutCode == 200) {
                            datas = res.Result.Table[0];

                            switch (indexe) {
                                case 1:
                                    if (!checked1) {
                                        mont = form.getFieldValue('MONTAN' + indexe) ? form.getFieldValue('MONTAN' + indexe) : 0
                                        form.setFieldValue('MONTAN' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MONTAN" + indexe, datas.commission)
                                    }
                                    setChecked1(!checked1)
                                    break;
                                case 2:
                                    if (!checked2) {
                                        mont = form.getFieldValue('MONTAN' + indexe) ? form.getFieldValue('MONTAN' + indexe) : 0
                                        form.setFieldValue('MONTAN' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MONTAN" + indexe, datas.commission)
                                    }
                                    setChecked2(!checked2)
                                    break;
                                case 3:
                                    if (!checked3) {
                                        mont = form.getFieldValue('MONTAN' + indexe) ? form.getFieldValue('MONTAN' + indexe) : 0
                                        form.setFieldValue('MONTAN' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MONTAN" + indexe, datas.commission)
                                    }
                                    setChecked3(!checked3)
                                    break;
                                case 4:
                                    if (!checked4) {
                                        mont = form.getFieldValue('MONTAN' + indexe) ? form.getFieldValue('MONTAN' + indexe) : 0
                                        form.setFieldValue('MONTAN' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MONTAN" + indexe, datas.commission)
                                    }
                                    setChecked4(!checked4)
                                    break;

                                default:
                                    break;
                            }
                            var montant = parseInt(form.getFieldValue('MONTAN' + indexe) + "") ? parseInt(form.getFieldValue('MONTAN' + indexe) + "") : 0
                            var total = parseInt(form.getFieldValue("cssionApliq") + "") ? parseInt(form.getFieldValue("cssionApliq") + "") : 0


                            switch (indexe) {
                                case 1:
                                    if (checked1) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                case 2:
                                    if (checked2) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                case 3:
                                    if (checked3) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                case 4:
                                    if (checked4) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                default:
                                    break;
                            }



                            form.setFieldValue("cssionApliq", total)
                            //SetData([{Code: datas.CODOPE, Libelle : datas.MONFIX, key: 0}])
                        }
                    }
                    //setLoadMont1(false);

                }).catch((error) => {
                    //console.log(error)
                    setChecked1(true);
                    setChecked2(true);
                    setChecked3(true);
                    setChecked4(true);


                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                }).finally(() => {
                    switch (indexe) {
                        case 1:
                            setLoadMont1(false);
                            break;
                        case 2:
                            setLoadMont2(false);
                            break;
                        case 3:
                            setLoadMont3(false);
                            break;
                        case 4:
                            setLoadMont4(false);
                            break;
                        // case 5:
                        //   setLoadMont5(false);
                        //   break;

                        default:
                            break;
                    }
                })
        }
        else {
            SweetAlert.fire({ title: "Veillez saisir le montant de la demande de prêt", icon: "warning" })
        }
    };

    //******************************************************************************************************** */

    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };


    // function getLimite

    function GetLimite() {

        if (form.getFieldValue("IDLIMITE") == null) {

        } else {
            let data = Crypter.encrypt(form.getFieldValue("IDLIMITE"));
            let IDLIMITE = form.getFieldValue("IDLIMITE")
            if (data.length != 0) {

                setLoading(true)

                form.setFieldValue("IDLIMITE", IDLIMITE)
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadLimite,
                    headers: {
                        'CypherNumordre': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                    //data: data
                };
                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            //console.log(JSON.stringify(res))
                            let limite = res.Result.Table[0]
                            //console.log(JSON.stringify(limite))

                            if (res.StatutCode == 200) {
                                // console.log(limite)
                                // form.setFieldsValue(limite);

                                // NivCons  MNTlimite  NUMOrdre
                                form.setFieldValue("MNTlimite", limite.MNTlimite)
                                form.setFieldValue("NivCons", limite.NivCons)
                                form.setFieldValue('datedebut', ReformatDate(limite.datedebut))
                                form.setFieldValue('Ldatefin', ReformatDate(limite.datefin))
                                form.setFieldValue("RESTANT", limite.MNTlimite - limite.NivCons)


                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Autorisation
                </span>
            ),
            children: <>
                <div className='tabItem' >

                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                            <Box fontStyle="inherit" >
                                <Box fontStyle="inherit" >

                                    <legend> Formulaire de création des autorisations </legend>
                                    <Box style={{ width: '100%' }}>
                                        <fieldset className="bordure1" style={{ marginTop: -10 }}>
                                            <Box style={{ display: 'flex', marginTop: 0, width: '100%' }}>
                                                <Box style={{ width: '100%' }}>
                                                    <Box style={{ marginTop: -8 }}>
                                                        <SearInputG width={6} dissabledCode={Libell} notRequired Titre=" Recherche" label={InfoDemandeAutorisation.numauto} name="NUMCRD" Taille1={'100%'} Taille2={0} Parametre={searchAutorisation} /* etat={setSearchGlobal} */ form={form} />
                                                    </Box>
                                                    <Box style={{ marginTop: -10 }}>
                                                        <SearInputModal width={6} Titre="Recherche" label={InfoDemandeAutorisation.idclt} name="NUMCLI" Taille1={'100%'} Taille2={'100%'} ExecuteafterSelect1={Getselectcli} Parametre={searchClient} form={form} />
                                                    </Box>
                                                    <Box style={{ marginTop: -10, marginBottom: -5 }}>
                                                        <SearInputModal width={6} Titre=" Recherche" label={InfoDemandeAutorisation.numcpte} ExecuteafterSelect1={handleConsultCompte} name="CPTAUT" Taille1={'100%'} Taille2={'100%'} Parametre={searchCompte} form={form} />
                                                    </Box>
                                                </Box>
                                                <Box style={{ width: '100%' }}>
                                                    <Box style={{ marginTop: -8 }}>
                                                        <SearInputModal width={6} Titre=" Recherche" label={InfoDemandeAutorisation.natcre} name="NATCRD" Taille1={'100%'} Taille2={'100%'} Parametre={searchNatcrd} form={form} />
                                                    </Box>
                                                    {/* <Box style={{ marginTop: -10 }}>
                                                        <SearInputModal width={6} Titre=" Recherche" label={InfoDemandeAutorisation.Libserv} name="SERVGE" Taille1={'100%'} Taille2={'100%'} Parametre={searchService} form={form} />
                                                    </Box> */}
                                                    <Box style={{ marginTop: -10, marginBottom: -5 }}>
                                                        <SearInputModal width={6} Titre=" Recherche" label={InfoDemandeAutorisation.libdevi} defaultCode="XAF" defaultLibelle="FRANC CFA BEAC" name="DEVAUT" Taille1={'100%'} Taille2={'100%'} Parametre={searchDevise} form={form} />
                                                    </Box>
                                                    <Box style={{  marginTop: -10, width: '88%' }}>
                                                        <InputForm disabled={true} label="Montant Disponible" name="DISPON" type="texte" />
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </fieldset>
                                        <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                            <Box style={{ display: 'flex', marginTop: 5, width: '100%' }}>
                                                <Box style={{ marginTop: -10, marginBottom: -7 }}>
                                                    <SearInputModal width={0} Titre=" Recherche" label={'Limite Associée'} name="IDLIMITE" Taille1={'100%'} Taille2={0} ExecuteafterSelect2={Getselectcli2} Parametre={searchlimite} form={form} />
                                                </Box>
                                                <Box style={{ marginLeft: -5, marginTop: -10, width: '24%', marginBottom: -7 }}>
                                                    <InputForm disabled={true} label={'Montant limite'} name="MNTlimite" type="string" />
                                                </Box>
                                                <Box style={{ marginLeft: -5, marginTop: -10, width: '21%', marginBottom: -7 }} >
                                                    <InputForm disabled={true} label={'Nivcons'} name="NivCons" type="number" />
                                                </Box>
                                                <Box style={{ marginLeft: -5, marginTop: -10, width: '21%', marginBottom: -7 }} >
                                                    <InputForm disabled={true} label={'Restant'} name="RESTANT" type="number" />
                                                </Box>
                                            </Box>
                                        </fieldset>
                                    </Box>

                                    <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                        <Box style={{ display: 'flex' }}>
                                            <Box style={{ width: '21%', marginTop: -5, marginBottom: -5 }}>
                                                <InputForm label="Montant" width={10} name="MNTAUT" type="number"  />
                                            </Box>
                                            <Box style={{ marginTop: -5, marginBottom: -5, width: '85%' }}>
                                                <InputForm width={3} label={InfoDemandeAutorisation.libgaranti} name="GARANT" type="string" />
                                            </Box>
                                        </Box>
                                    </fieldset>
                                    <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                        <Box style={{ display: 'flex', marginTop: -8 }}>
                                            <Box style={{ marginBottom: -7, width: '25%' }}>
                                                <InputForm label="date effet" defaultValue={Perss.datjour} width={0} name="DATEFF" type="date" />
                                            </Box>
                                            <Box style={{ marginBottom: -7, width: '25%' }}>
                                                <InputForm label="date fin" defaultValue={Perss.datjour} name="DATEFIN" type="date" width={0} />
                                            </Box>
                                            <Box style={{ marginBottom: -7, width: '25%' }}>
                                                <InputForm disabled={true} label="Date limite debut" width={0} name="datedebut" type="date" />
                                            </Box>
                                            <Box style={{ marginBottom: -7, width: '25%' }}>
                                                <InputForm disabled={true} label="Date limite fin" name="Ldatefin" type="date" width={0} />
                                            </Box>
                                        </Box>
                                    </fieldset>

                                </Box>
                                <Box >
                                    <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                        <Box style={{ paddingLeft: 10, display: 'flex' }}>
                                            <Box fontStyle="inherit" >
                                                {commissions.map((cssion, indexe) => (
                                                    <Box marginTop={1} >
                                                        <Checkbox style={{ marginTop: -5 }} checked={!tabCheck[indexe]} onChange={() => { onChange(cssion) }}>
                                                            <SearInputM width={6} defaultCode={cssion.code} defaultLibelle={cssion.label} form={form} Titre={'Recherche Type Commission ' + (indexe + 1)} label={'Commission.. ' + (indexe + 1)} name={'CODOP' + (indexe + 1)} Parametre={searchCsion} />
                                                        </Checkbox>
                                                    </Box>
                                                ))}
                                            </Box>
                                            <Box>
                                                <Box style={{}}>
                                                    <InputForm min={0} defaultValue='0' onChange={(e) => { change(e, 1) }} width={9} label={'Montant 1'} name={'MONTAN1'} type='number' error='mobile' />
                                                </Box>
                                                <Box style={{ marginTop: -7 }}>
                                                    <InputForm min={0} defaultValue='0' onChange={(e) => { change(e, 2) }} width={9} label={'Montant 2'} name={'MONTAN2'} type='number' error='mobile' />
                                                </Box>
                                                <Box style={{ marginTop: -7 }}>
                                                    <InputForm min={0} defaultValue='0' onChange={(e) => { change(e, 3) }} width={9} label={'Montant 3'} name={'MONTAN3'} type='number' error='mobile' />
                                                </Box>
                                                {/* <Box style={{ marginTop: -7 }}>
                                                    <InputForm min={0} defaultValue='0' onChange={(e) => { change(e, 4) }} width={9} label={'Montant 4'} name={'MONTAN4'} type='number' error='mobile' />
                                                </Box> */}
                                            </Box>
                                        </Box>
                                    </fieldset>
                                </Box>


                            </Box>

                        </Box>
                    </div>
                </div >
            </>,
        },
    ];

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> DEMANDE AUTORISATION : {window.location.pathname.toUpperCase()} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult(); }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { handleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { SetOnfinis(11); handleModife() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={true} onClick={() => { SetOnfinis(2); handleSupprim() }} type="ghost" htmlType="button" block>
                                    Supprimer
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                      Imprimer
                    </Button> */}
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { handleActual(); }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { handleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" defaultActiveKey="1" items={items} >

                            </Tabs>

                        </div>
                        <div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}
export default AddAutorisation;